import { useEffect, useState } from "react";
import axios from "axios";

// The Gallery component shows all of an artist's artworks created through the FRACTAL 
// application.

// IMPORTANT: Gallery was designed to be used in concert with the ArtworkMagnifier component.
// See use in Profile.jsx

// Required props: 
// - artist (user object, including recent gallery field)
// - artSelector (function)
function Gallery(props) {
    const imagePrefix = "data:image/png;base64,"; // Used to render base 64 images

    const [isLoading, setIsLoading] = useState(true); // Are we awaiting a response from image API calls?
    const [recentGallery, setRecentGallery] = useState([]); // Gallery of images recently created by artist

    let artist = props.artist;

    // Get images from artist's recent and saved galleries
    useEffect(() => {
        let recentGalleryID = artist.recent;

        // Get images from artist's recent gallery
        axios.get("/api/images/?gallery=" + recentGalleryID)
        .then((response) => {
            setRecentGallery(response.data);
            setIsLoading(false);
        })
    }, [artist]);

    // Convert timestamp to local time.
    function convertDateAndTime(timestamp) {
        let dateObj = new Date(timestamp);

        // Convert to local time
        return dateObj.toLocaleString("en-US");
    }

    return (
        <>
            {recentGallery.length > 0 ? (
                <>
                    <p> {/* Gallery header, i.e. John's Gallery: */}
                        {artist.first_name}'
                        {artist.first_name.substring(artist.first_name.length - 1) != "s" && "s"} 
                        {" "}Gallery:
                    </p>
                    <div className="gallery"> {/* Recent Gallery */}
                        {recentGallery.map((image) => 
                            <img 
                                onClick={props.artSelector} 
                                data-prompt={image.prompt}
                                data-studio={image.studio}
                                data-artist={artist.first_name + " " + artist.last_name}
                                data-timestamp={convertDateAndTime(image.created_at)}
                                data-id={image.imageID}
                                src={imagePrefix + image.picture}
                            />
                        )}
                    </div>
                </>
            ) : (isLoading ? (<p>Loading...</p>) : (<p>{artist.first_name} has not created any images yet.</p>))}
        </>
    )
}

export default Gallery;